//Quick View
$(document).ready(function () {
    $.getScript("//cdnjs.cloudflare.com/ajax/libs/fancybox/2.1.5/jquery.fancybox.min.js").done(function() {
      quickView();
    });
   });
    

   function quickView() {
       var variant_id="";
    $(".quick-view").click(function () {
      if ($('#quick-view').length == 0){$("body").append('<div id="quick-view"></div>');}
      var product_handle = $(this).data('handle');
      $('#quick-view').addClass(product_handle);
      jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
        if(product.variants.length>1){
        var VariantsToHide=JSON.parse($('.VariantsToHide').val())
        var ProductVariantsToHide=[];
        for( VariantToHide of VariantsToHide){
            if(VariantToHide.variantid==product.variants[0].id){
              ProductVariantsToHide.push(product.variants[0].id);
            }  
            if(VariantToHide.variantid==product.variants[1].id){
              ProductVariantsToHide.push(product.variants[1].id);
            }         
        }
        }

        $('og-offer').attr("product",product.variants[0].id);
        var title = product.title;
        var type = product.type;
        window.variant_id=product.variants[0].id;
        window.global_product=product;
        var images = product.images;
        var url = '/products/' + product_handle;
        var dataDropDown=$('.dataDropDown').val();
        var saves=JSON.parse(dataDropDown);
        window.regularPrice = product.variants[0].price;
        window.comparePrice =product.variants[0].compare_at_price||'';
        dropItems=false
        for(save of saves){
            for(tag of product.tags){
               if(tag===save.tag){ 
                dropItems=save.dropitems
                $('.custom-select').find("select").find('option').eq(0).html(dropItems[0].label);
                $('.custom-select').find("select").find('option').eq(0).val(dropItems[0].value);
               } 
            }
           
        }
      if(dropItems && ProductVariantsToHide.length==0){
        var i=0;
        $('.select-selected').html(dropItems[0].label)
        for(dropItem of dropItems){
          $('.select-items').find('div').eq(i).html(dropItem.label);
          $('.custom-select').find("select").find('option').eq(i+1).html(dropItem.label);
          $('.custom-select').find("select").find('option').eq(i+1).val(dropItem.value);
        i=i+1;
        }
      }else{
        $('.custom-select').remove();
      }
   
        if(product.variants.length>1 && ProductVariantsToHide.length==0){
      
          var head= document.getElementsByTagName('head')[0];


        $('.switcherLeft').html(product.variants[0].title);
        $('.switcherLeft').attr("data_regular_price",product.variants[0].price)
        $('.switcherLeft').attr("data_compare_at_price",product.variants[0].compare_at_price||'')
        $('.switcherLeft').attr("value",product.variants[0].id)
        $('.switcherRight').html(product.variants[1].title)
        $('.switcherRight').attr("data_regular_price",product.variants[1].price)
        $('.switcherRight').attr("data_compare_at_price",product.variants[1].compare_at_price||'')
        $('.switcherRight').attr("value",product.variants[1].id)
        }else{
          $('.switch').remove();
        }
       
       if(ProductVariantsToHide[0]==product.variants[0].id){
        $('[name="id"]').val(product.variants[1].id);
       }else{
         $('[name="id"]').val(product.variants[0].id);
       }
       


        $('[name="id"]').attr("data-productid",product.id);
       
        $('.qv-product-title').text(title);
        $('.qv-product-type').text(type);
        $('.view-product').attr('href', url);
        var imageCount = $(images).length;
        $(".current_price").html("$"+Number(product.price/100).toFixed(2))
        if(product.compare_at_price){
            $(".was_price").html("$"+Number(product.compare_at_price/100).toFixed(2))
            $('.percent_saved').html(Number((product.compare_at_price-product.price)*100/product.compare_at_price).toFixed(2));
        }else
        {
            $('#testSavePercent').remove()
        }

        var carousel_container= $("<div class='carousel-container'><ul class='carousel product-carousel'></ul></div>");
      $(product.media).each(function (i, image) {
        if(image.media_type=="image"){
        var df=""
        if(i==0)
        df="default_slide";
        if(ProductVariantsToHide[0]==product.variants[0].id){
          var IDV=product.variants[1].id;
         }else{
          var IDV=product.variants[0].id;
         }
        
       if(product.variants.length>1){
        var ALT=""+image.alt+"";
        
        if(ALT.includes(""+product.variants[0].title)){
           IDV=product.variants[0].id;
        }
        if(ALT.includes(""+product.variants[1].title)){
          IDV=product.variants[1].id;
        }
      }
        item=$('<li data-full="'+image.src+'" data-variant="'+IDV+'"  data-default="'+IDV+'" class="variant_slide size-11 slick-slide slick-current slick-active '+df+'" ><img src="'+image.src+'"  sizes="(min-width: 1600px) 960px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)" loading="lazy" width="100%" height="100%" alt="q_1 main-product-image"></li>');
          carousel_container.find('ul').append(item)
          }
       });

      var carousel_nav=$('<div class="carousel-nav carousel-nav--vertical"><ul class="carousel-nav-list"></ul></div>');
          $(product.media).each(function (i, image) {
            if(image.media_type =="image"){
            var df=""
            if(i==0)
            df="active";
            item=$('<li class="carousel-nav-item '+df+'"></li><img src="'+image.src+'"  sizes="(min-width: 1600px) 960px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)" loading="lazy" width="100%" height="100%" alt="q_1 main-product-image"></li>');
            carousel_nav.find('ul').append(item)
            }
          });
          $('<span class="carousel-btn prev-img nav-btn"><i class="fa fa-1-5x fa-chevron-up" aria-hidden="true"></i></span>').insertBefore(carousel_nav.find('ul'))
          $('<span class="carousel-btn next-img nav-btn"><i class="fa fa-1-5x fa-chevron-down" aria-hidden="true"></i></span>').insertAfter(carousel_nav.find('ul'))
      
    
      $('.qv-product-images').append(carousel_container);
      
      $('.qv-product-images').find('.carousel-container').append(carousel_nav)
       
        window.product =product;
        var head= document.getElementsByTagName('head')[0];
        var script1= document.createElement('script');
        script1.src= $('.DropDonwScript').val();
        script= document.createElement('script'); 
        script.src= $('.carouselScript').val();
        setTimeout(function(){head.appendChild(script1); head.appendChild(script);},1500);
        
        $('og-when').find('og-optout-button').click(function(){
          setTimeout(priceCheck,200);
        })
        $('og-when').find('og-optin-button').click(function(){
          setTimeout(priceCheck,200);
        })

       
        qty=1;
      });

      $.fancybox({
        href: '#quick-view',
        maxWidth: 1040,
        maxHeight: 900,
        fitToView: true,
        width: '75%',
        height: '82%',
        autoSize: false,
        closeClick: false,
        openEffect: 'none',
        closeEffect: 'none',
        'beforeLoad': function () {
            $('#quick-view').html("");
          var product_handle = $('#quick-view').attr('class');


          $(document).on("click", "#QvAddToCart", function () {
            if($('og-when').find('og-optout-button').attr("subscribed")!=undefined){
                 SubScrib_addToCart();
            }else{
     
                regular_addToCart();
            }
              


          });


          $('.fancybox-wrap').css('overflow', 'hidden !important');
        },
        'afterShow': function () {
          $('#quick-view').hide().html(content).css('opacity', '1').fadeIn(function () {
            $('.qv-product-images').addClass('loaded');
          });
        },
        'afterClose': function () {
          $('#quick-view').removeClass().empty();
        }
      });
    });
   };


   function SubScrib_addToCart ( ) {
    
    data = {
      "quantity":1,
      "id": $('[name="id"]').val(),
      "selling_plan":"787742901",
      "properties":{
        "compare_at_price": window.comparePrice
      }
    }
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      cache: false,
      success: function(itemData) {
        $.getJSON("/cart.js", function(cart) {
          refreshCart(cart);
          window.setTimeout(function(){ $('.cart-button')[0].click(); }, 100);
        });
      },
      error: function(XMLHttpRequest) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
        $('.warning').remove();
        var warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
      }
    });
   }

   function regular_addToCart(){
    jQuery.post('/cart/add.js', {
        quantity: $('[name="quantity"]').val() || 1,
        id: $('[name="id"]').val(),
        properties:{compare_at_price:window.comparePrice}
      },
     null,
     "json"
     ).done(function () {
        $('.qv-add-to-cart-response').addClass('success').html('<span>' + $('.qv-product-title').text() + ' has been added to your cart. <a href="/cart">Click here to view your cart.</a>');
        $.getJSON("/cart.js", function(cart) {
            refreshCart(cart);
            window.setTimeout(function(){ $('.cart-button')[0].click(); }, 100);
          });  
    })
      .fail(function ($xhr) {
        var data = $xhr.responseJSON;
        $('.qv-add-to-cart-response').addClass('error').html('<span><b>ERROR: </b>' + data.description);
      });
   }




 



   
